

import Button from '../../../components/base/Button';

export default function FeaturedProductsSection() {
  const featuredProducts = [
    {
      id: 1,
      name: '顺泰味（2008年）',
      subtitle: '珍藏版限量发售',
      price: '¥2,888',
      originalPrice: '¥3,288',
      image: 'https://public.readdy.ai/ai/img_res/f56db05a338eeb282c7905af3e25e5ad.jpg',
      description: '2008年珍品，历经17年自然陈化，茶汤红润，陈香浓郁，回甘悠长，是茶友珍藏的不二之选。',
      features: ['17年陈化', '限量发售', '收藏证书', '原产地认证']
    },
    {
      id: 2,
      name: '七星茶王六堡茶',
      subtitle: '获奖产品',
      price: '¥1,588',
      originalPrice: '¥1,888',
      image: 'https://readdy.ai/api/search-image?query=Award-winning%20Liu%20Bao%20tea%20with%20seven%20stars%20design%20packaging%2C%20premium%20Chinese%20dark%20tea%20with%20golden%20medal%20elements%2C%20luxury%20tea%20product%20photography%2C%20elegant%20presentation%2C%20sophisticated%20styling%2C%20traditional%20craftsmanship%20display%2C%20high-end%20commercial%20photography&width=600&height=600&seq=featured-seven-stars&orientation=squarish',
      description: '荣获七星茶王奖，选用优质六堡茶原料，传统工艺精制而成，槟榔香韵独特，口感醇厚甘甜。',
      features: ['获奖产品', '槟榔香韵', '传统工艺', '品质保证']
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="mx-auto px-6 lg:px-[15%]">
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-4xl font-bold text-[#663333] mb-4">
            精选推荐
          </h2>
          <p className="text-sm sm:text-lg text-gray-600">
            臻选珍品，匠心呈现
          </p>
          <div className="w-24 h-1 bg-[#cc9966] mx-auto mt-4"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {featuredProducts.map((product) => (
            <div
              key={product.id}
              className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100"
              data-product-shop
            >
              <div className="grid grid-cols-1 md:grid-cols-2">
                <div className="aspect-square overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                  />
                </div>
                
                <div className="p-8 flex flex-col justify-between">
                  <div>
                    <div className="mb-4">
                      <h3 className="text-lg sm:text-xl font-bold text-[#663333] mb-2">
                        {product.name}
                      </h3>
                      <p className="text-xs sm:text-sm text-[#cc9966] font-medium">
                        {product.subtitle}
                      </p>
                    </div>
                    
                    <div className="flex items-center mb-4">
                      <span className="text-lg sm:text-xl font-bold text-[#cc9966]">
                        {product.price}
                      </span>
                      <span className="text-sm sm:text-base text-gray-400 line-through ml-3">
                        {product.originalPrice}
                      </span>
                    </div>
                    
                    <p className="text-xs sm:text-sm text-gray-600 mb-6 leading-relaxed">
                      {product.description}
                    </p>
                    
                    <div className="flex flex-wrap gap-2 mb-6">
                      {product.features.map((feature, index) => (
                        <span
                          key={index}
                          className="bg-[#cc9966]/10 text-[#cc9966] text-xs px-3 py-1 rounded-full"
                        >
                          {feature}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  <div className="flex gap-3">
                    <Button 
                      variant="primary" 
                      size="sm"
                      className="flex-1 rounded-full bg-[#cc9966] hover:bg-[#bb8855] text-xs sm:text-sm"
                    >
                      立即购买
                    </Button>
                    <Button 
                      variant="outline" 
                      size="sm"
                      className="rounded-full border-[#cc9966] text-[#cc9966] hover:bg-[#cc9966] hover:text-white text-xs sm:text-sm"
                    >
                      了解详情
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
